/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PrecautionsCard from "./PrecautionsCard";
import RiskLevelsCard from "./RiskLevelsCard";

function HazardDetails({
  hazard,
  getRiskLevelColor,
  onUnlinkPrecaution,
  deletingPrecaution,
  onAddPrecaution,
  onAddPrecautionWithCategory,
}) {
  const { t } = useTranslation();

  if (
    !hazard.precaution_categories ||
    hazard.precaution_categories.length === 0
  ) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          {t("hazards.noPrecautionsAvailable")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        flexDirection: { xs: "column", sm: "column", md: "row" },
        width: "100%",
        alignItems: { xs: "stretch", sm: "stretch", md: "stretch" },
      }}
    >
      <Box
        sx={{
          flex: { xs: "none", sm: "none", md: "1 1 60%" },
          width: { xs: "100%", sm: "100%", md: "auto" },
          minWidth: 0,
          display: "flex",
        }}
      >
        <PrecautionsCard
          categories={hazard.precaution_categories}
          hazardId={hazard.id}
          onUnlinkPrecaution={onUnlinkPrecaution}
          deletingPrecaution={deletingPrecaution}
          onAddPrecaution={onAddPrecaution}
          onAddPrecautionWithCategory={onAddPrecautionWithCategory}
        />
      </Box>
      <Box
        sx={{
          flex: { xs: "none", sm: "none", md: "1 1 40%" },
          width: { xs: "100%", sm: "100%", md: "auto" },
          minWidth: 0,
          display: "flex",
        }}
      >
        <RiskLevelsCard hazard={hazard} getRiskLevelColor={getRiskLevelColor} />
      </Box>
    </Box>
  );
}

export default HazardDetails;
